<mat-nav-list>
  @for (link of links; track link) {
    <a mat-list-item (click)="link.clickHandler(); onOpenLink($event)" data-test="link-button">
      <span mat-line>{{ link.title }}</span>
    </a>
  }
</mat-nav-list>
